import { render } from "./SlideDown.vue?vue&type=template&id=0b403518&scoped=true"
import script from "./SlideDown.vue?vue&type=script&lang=js"
export * from "./SlideDown.vue?vue&type=script&lang=js"

import "./SlideDown.vue?vue&type=style&index=0&id=0b403518&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b403518"]])

export default __exports__